import React, { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import THEORY from "../../shared/THEORY";

import RulesSideBar from "../components/sideBar/RulesSideBar";
import Rule from "../components/Rule";
import TicketsSideBarMobileChecker from "../../tickets/components/Sidebar/TicketsSideBarMobileChecker";

const RulesMode = (props) => {
  const history = useHistory();

  const switchRule = useCallback(() => {
    switch (props.rulesType) {
      case "rules":
        props.setLoadedRule(THEORY.rules.items[props.paramsRuleId - 1]);
        break;
      case "signs":
        props.setLoadedRule(THEORY.signs.items[props.paramsRuleId - 1]);
        break;
      case "marks":
        props.setLoadedRule(THEORY.marks.items[props.paramsRuleId - 1]);
        break;
      case "access":
        props.setLoadedRule(THEORY.access.items[props.paramsRuleId - 1]);
        break;
      default:
        break;
    }
  }, [props]);

  if (!props.loadedRule) {
    switchRule();
  }
  useEffect(() => {
    switchRule();
  }, [history, props, switchRule]);

  if (!props.loadedRule) {
    return <div>Loading...</div>;
  }
  return (
    <div className="grid-container">
      <div className="dash-board">
        <Rule currentRule={props.loadedRule} rulesArray={THEORY} />
      </div>
      <TicketsSideBarMobileChecker he="Правила">
        {(params) =>
          params ? (
            <RulesSideBar
              rulesArray={THEORY}
              closeSideBarMobile={params.closeDrawerHandler}
            />
          ) : (
            <div className="side-bar">

              <RulesSideBar rulesArray={THEORY} />

              <div style={{ maxHeight: "610px" }} className="my-1 sticky">
                <div id="yandex_rtb_R-A-1691059-6"></div>
                <script>{window.yaContextCb.push(() => {
                  window.Ya.Context.AdvManager.render({
                    renderTo: 'yandex_rtb_R-A-1691059-6',
                    blockId: 'R-A-1691059-6'
                  })
                })}</script>
              </div>

            </div>
          )
        }
      </TicketsSideBarMobileChecker>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    rulesArray: state.ticketsReducer.ticketsArray,
    loadedRule: state.ticketsReducer.loadedBilet,
    rulesType: state.router.location.pathname.split("/")[1],
    paramsRuleId: state.router.location.pathname.split("/")[2],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setLoadedRule: (loadedRule) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedRule,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RulesMode);